import React from "react";
import { Label } from "@fluentui/react";
import { useCommonControlsStyle } from "../../theme/styles/CommonControlsStyle";

/**
 * Small red validation text shown directly under a required field.
 */
export default function FieldValidationMessage({
  message,
  align = "left",
  compact = false,
}) {
  const styleTheme = useCommonControlsStyle();
  if (!message) {
    return null;
  }

  return (
    <Label
      style={{
        ...styleTheme.LabelErrorMessageStyle,
        textAlign: align,
        fontSize: 10,
        width: "100%",
        display: "block",
        marginTop: compact ? 0 : 4,
        marginBottom: 0,
        padding: 0,
        lineHeight: 1.2,
      }}
    >
      {message}
    </Label>
  );
}
